module.exports = __webpack_public_path__ + "static/img/bg_bmtop@2x.5e1d647f.png";